"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paths = void 0;
const path_to_regexp_1 = require("path-to-regexp");
exports.paths = {
    toRegexp: (path) => {
        try {
            return (0, path_to_regexp_1.pathToRegexp)(path);
        }
        catch (e) {
            throw new Error(`Invalid path: ${path}.\nConsult the documentation of path-to-regexp here: https://github.com/pillarjs/path-to-regexp.\n${e.message}`);
        }
    },
};
